/* eslint-disable */
import { ApiPost } from '../util/axios'
import { consoleLog, getObjectAsArray } from '../util'

const getLanguagesApi = async data => {
  const options = {
    reqId: 'GetLanguages',
    payload: data,
    resId: 'GetLanguagesResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getCountriesApi = async data => {
  const options = {
    reqId: 'GetCountries',
    payload: data,
    resId: 'GetCountriesResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getStatesApi = async data => {
  const options = {
    reqId: 'GetStates',
    payload: data,
    resId: 'GetStatesResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationUserApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationUser',
    payload: data,
    resId: 'GetOrganizationAggregationUserResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationItemApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationItem',
    payload: data,
    resId: 'GetOrganizationAggregationItemResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordTypesForNotesApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordTypesForNotes',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordTypesForNotesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordSubTypesForNotesTypeApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordSubTypesForNotesType',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordSubTypesForNotesTypeResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationSubKeywordLevel1ForKeywordLevel1Api = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationSubKeywordLevel1ForKeywordLevel1',
    payload: data,
    resId: 'GetOrganizationAggregationSubKeywordLevel1ForKeywordLevel1Result',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationSubKeywordLevel1ForKeywordApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationSubKeywordLevel1ForKeyword',
    payload: data,
    resId: 'GetOrganizationAggregationSubKeywordLevel1ForKeywordResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationSubKeywordLevel2ForKeywordLevel1Api = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationSubKeywordLevel2ForKeywordLevel1',
    payload: data,
    resId: 'GetOrganizationAggregationSubKeywordLevel2ForKeywordLevel1Result',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordsApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywords',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordsResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordNotesApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordNotes',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordNotesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordSubTypesApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordSubTypes',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordSubTypesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationKeywordTypesApi = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationKeywordTypes',
    payload: data,
    resId: 'GetOrganizationAggregationKeywordTypesResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationQuestionFuncApi = async data => {
  const optionArray = [{}]
  for(let i=1; i<=15; i++){
    optionArray.push({
      reqId: `GetOrganizationAggregationQuestion${i}`,
      payload: data,
      resId: `GetOrganizationAggregationQuestion${i}Result`,
      resType: 'object'
    })
  }

  const questionArray = []
  for(let i=1; i<15; i++){
    if(i === 8 || i === 9 || i === 10){
      questionArray.push('')
    } else {
      let question = await ApiPost(optionArray[i])
      // if(i===1 && question?.[0] >= 0){
      if(i>=1 && question?.[0] >= 0){
        question = question.map(d => d + '')
        // HERE QUESTION1 WAS CONTAINING NUMBER AND SO HAVE CONVERTED IT TO A STRING.
      }
      const finalData = Object.keys(getObjectAsArray(question)[0]).length === 0 ? [] : getObjectAsArray(question)
      questionArray.push(finalData)
    }
  }

  return await ApiPost(optionArray[15]).then((res) => {
    const finalData = Object.keys(getObjectAsArray(res)[0]).length === 0 ? [] : getObjectAsArray(res)
    questionArray.push(getObjectAsArray(finalData))
    return questionArray
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationSingleQuestionFuncApi = async (data, index) => {
  const options = {
    reqId: `GetOrganizationAggregationQuestion${index}`,
    payload: data,
    resId: `GetOrganizationAggregationQuestion${index}Result`,
    resType: 'object'
  }

  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationUserLocalQuestionFuncApi = async data => {
  const optionArray = [{}]
  for(let i=1; i<=12; i++){
    optionArray.push({
      reqId: `GetOrganizationAggregationUserLocalQuestion${i}`,
      payload: data,
      resId: `GetOrganizationAggregationUserLocalQuestion${i}Result`,
      resType: 'object'
    })
  }

  const questionArray = []
  for(let i=1; i<12; i++){
    if(i === 6){
      questionArray.push('')
    } else {
      const question = await ApiPost(optionArray[i])
      const question1 = getObjectAsArray(question)
      const question2 = question1.length > 0 ? question1.map(f => f+'') : []
      const finalData = ((Object.keys(question2[0]).length === 0 || question2[0] === '[object Object]') ? [] : question2)
      questionArray.push(finalData)
    }
  }

  return await ApiPost(optionArray[12]).then((res) => {
    const finalData = Object.keys(getObjectAsArray(res)[0]).length === 0 ? [] : getObjectAsArray(res)
    questionArray.push(getObjectAsArray(finalData))
    return questionArray
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getGlobalQuestion1Api = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationUserGlobalQuestion1',
    payload: data,
    resId: 'GetOrganizationAggregationUserGlobalQuestion1Result',
    resType: 'array'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationQuestionMulti1Api = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationQuestionMulti1',
    payload: data,
    resId: 'GetOrganizationAggregationQuestionMulti1Result',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getOrganizationAggregationQuestionMulti2Api = async data => {
  const options = {
    reqId: 'GetOrganizationAggregationQuestionMulti2',
    payload: data,
    resId: 'GetOrganizationAggregationQuestionMulti2Result',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const updateAggregationItemAndUserApi = async data => {
  const options = {
    reqId: 'UpdateAggregationItemAndUser',
    payload: data,
    resId: 'UpdateAggregationItemAndUserResult',
    resType: 'object',
    getLatest: true
  }
  console.log('socialMonitorEdit > save > Method: updateAggregationItemAndUserApi > Payload : ', data)

  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    // 
    console.log('socialMonitorEdit > save > Method: updateAggregationItemAndUserApi > Error : ', error)
    consoleLog('error 2 - ', error, data)
    return error
  })
}

const setBareBoneAggregationItemAndUserApi = async data => {
  const options = {
    reqId: 'SetBareBoneAggregationItemAndUser',
    payload: data,
    resId: 'SetBareBoneAggregationItemAndUserResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setBareBoneAggregationItemAndUserInOrganizationApi = async data => {
  const options = {
    reqId: 'SetBareBoneAggregationItemAndUserInOrganization',
    payload: data,
    resId: 'SetBareBoneAggregationItemAndUserInOrganizationResult',
    resType: 'object',
    getLatest: true
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

export default {
  getLanguagesApi,
  getCountriesApi,
  getStatesApi,
  getOrganizationAggregationUserApi,
  getOrganizationAggregationItemApi,
  getOrganizationAggregationKeywordTypesForNotesApi,
  getOrganizationAggregationKeywordSubTypesForNotesTypeApi,
  getOrganizationAggregationSubKeywordLevel1ForKeywordLevel1Api,
  getOrganizationAggregationSubKeywordLevel1ForKeywordApi,
  getOrganizationAggregationSubKeywordLevel2ForKeywordLevel1Api,
  getOrganizationAggregationKeywordsApi,
  getOrganizationAggregationKeywordNotesApi,
  getOrganizationAggregationKeywordSubTypesApi,
  getOrganizationAggregationKeywordTypesApi,

  getOrganizationAggregationQuestionFuncApi,
  getOrganizationAggregationUserLocalQuestionFuncApi,
  getGlobalQuestion1Api,
  getOrganizationAggregationQuestionMulti1Api,
  getOrganizationAggregationQuestionMulti2Api,
  updateAggregationItemAndUserApi,
  getOrganizationAggregationSingleQuestionFuncApi,
  setBareBoneAggregationItemAndUserApi,
  setBareBoneAggregationItemAndUserInOrganizationApi
}